import { DatePicker, Form, Input, InputNumber, Select } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { closeDrawer, useAppDispatch, useDrawer, useForm } from '../../../core';
import { ISubscriptionPromoCodeAttributes } from '../types/promo-code.types';

type TProps = {
  isSubmitted: boolean;
  onFinish: (values: any) => void;
};

export const PromoCodeForm: React.FC<TProps> = ({ onFinish, isSubmitted }) => {
  const { form } = useForm({ drawerId: 'PromoCodeDrawer' });
  const dispatch = useAppDispatch();
  const { resource, open } = useDrawer<ISubscriptionPromoCodeAttributes>();

  useEffect(() => {
    if (!isSubmitted) {
      return;
    }

    dispatch(closeDrawer());
  }, [isSubmitted, dispatch, form]);

  useEffect(() => {
    if (open) {
      return;
    }

    form.resetFields();
  }, [open, form]);

  useEffect(() => {
    console.log(resource);
    if (!resource) {
      return;
    }

    form.setFieldsValue({
      code: resource.code,
      type: resource.type,
      quantity: resource.quantity,
      expireAt: dayjs(resource.expireAt),
      value: resource.value,
    });
  }, [form, resource]);

  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      style={{ maxWidth: 600 }}
      onFinish={onFinish}
    >
      <Form.Item
        name="code"
        label="Code"
        required
        rules={[
          { required: true },
          {
            pattern: /^[A-Z0-9]+$/,
            message: 'Code can only contain letters and numbers (no spaces)',
          },
        ]}
      >
        <Input
          onKeyUp={(e) =>
            form.setFieldValue(
              'code',
              e.currentTarget.value.toUpperCase().replace(/\s/g, ''),
            )
          }
        />
      </Form.Item>
      <Form.Item name="type" label="Type" required rules={[{ required: true }]}>
        <Select
          options={[
            { label: 'Percentage', value: 'percentage' },
            { label: 'Fixed', value: 'fixed' },
          ]}
        />
      </Form.Item>
      <Form.Item
        name="quantity"
        label="Quantity"
        required
        rules={[{ required: true }]}
      >
        <InputNumber min={1} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        name="expireAt"
        label="Expires At"
        required
        rules={[{ required: true }]}
      >
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item
        name="value"
        label="Value"
        required
        rules={[{ required: true }]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
    </Form>
  );
};
